/**
 * @description 支持备用域名访问页面，以备主站域名意外被封时使用
 */
export var onlineDomain = (window.Session && window.Session.preset_config && window.Session.preset_config.mainUrl) || 'https://m.lizhiweike.com';
export var judgeHost = /(dbg.lizhiweike.com)|(tryweike.cn:3002)|(localhost)/.test(window.location.host) ? 'https://dbg.lizhiweike.com' : onlineDomain;



//////////////////
// WEBPACK FOOTER
// ./src/config/index.ts
// module id = 134
// module chunks = 39